import { React } from 'react'
import { Grid } from '@mui/material'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import { useTheme } from '@mui/styles'
import JobViewComponent from './JobViewComponent'
import AIDashboard from './AIDashboard'

export default function DashboardEmployer (props) {
  const theme = useTheme()
  return (
    <Grid container>
      <Grid item xs={12}>
        {/* <AIDashboard /> */}

        {/* new section */}
        <TextBold style={{ fontSize: 24 }}>Performance of Active Jobs</TextBold>
        <JobViewComponent />
      </Grid>
    </Grid>
  )
}
